/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import {
    ClickAwayListener,
    Divider,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Popper,
    Typography,
    useMediaQuery
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import MainCard from "components/MainCard";
import Transitions from "components/Transitions";
import { SVGIcons } from "cms/icons/svg-icons";
import NotificationItem from "./Notification-Item";

// sx styles
const avatarSX = {
    width: 36,
    height: 36,
    fontSize: "1rem",
};

const actionSX = {
    mt: "6px",
    ml: 1,
    top: "auto",
    right: "auto",
    alignSelf: "flex-start",

    transform: "none",
};

// ==============================|| HEADER CONTENT - NOTIFICATION ||============================== //

const Notification = (props) => {
    const { open, setOpen, anchorRef } = props || {};
    const navigate = useNavigate();
    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down("md"));

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const handleToggle = async () => {
        setOpen(!open);
    };
    const handleItemClick = async (e, task) => {
        if (task === "manage-tasks") {
            navigate("/tasks");
        } else {
            // TODO: implement task destinations
            navigate("/tasks");
        }
        setOpen(!open);
    };

    return (
        <Popper
            placement={matchesXs ? "bottom" : "bottom-end"}
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            style={{ zIndex: 30000 }}
            transition
            disablePortal
            popperOptions={{ modifiers: [{ name: "offset", options: { offset: [matchesXs ? -5 : 0, 9] } } ] }}
        >
            {({ TransitionProps }) => (
                <Transitions type='fade' in={open} {...TransitionProps}>
                    <Paper
                        sx={{
                            boxShadow: theme.customShadows.z1,
                            width: "100%",
                            minWidth: 285,
                            maxWidth: 420,
                            [theme.breakpoints.down("md")]: {
                                maxWidth: 285,
                            },
                        }}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <MainCard
                                title='Tasks'
                                elevation={0}
                                border={false}
                                content={false}
                                secondary={
                                    <IconButton size='small' onClick={handleToggle}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            >
                                <List
                                    component='nav'
                                    sx={{
                                        p: 0,
                                        "& .MuiListItemButton-root": {
                                            py: 0.5,
                                            "& .MuiAvatar-root": avatarSX,
                                            "& .MuiListItemSecondaryAction-root": {
                                                ...actionSX,
                                                position: "relative",
                                            },
                                        },
                                    }}
                                >
                                    <NotificationItem
                                        iconColour = '#FFFFFF'
                                        iconBackgroundColour = '#00685E'
                                        icon = {<SVGIcons.models.News />}
                                        when = '3:08 PM'
                                        textMain = 'Review: New sidewalks on King street'
                                        textSub = 'Due: October 12, 5:00 PM'
                                        target = 'manage-tasks'
                                        handleItemClick={handleItemClick}
                                    />
                                    
                                    <Divider />
                                    
                                    <NotificationItem
                                        iconColour = '#FFFFFF'
                                        iconBackgroundColour = '#00685E'
                                        icon = {<SVGIcons.models.Story />}
                                        when = '3:08 PM'
                                        textMain = 'New Story content in progress'
                                        textSub = 'Started: October 1, 2:04 PM'
                                        target = 'manage-tasks'
                                        handleItemClick={handleItemClick}
                                    />
                                    <Divider />
                                    
                                    <NotificationItem
                                        iconColour = '#FFFFFF'
                                        iconBackgroundColour = '#DFDFDF'
                                        icon = 'B'
                                        when = '12:21 PM'
                                        textMain = 'Comment from Briana'
                                        textSub = 'Updated: October 5, 12:21 PM'
                                        target = 'manage-tasks'
                                        handleItemClick={handleItemClick}
                                    />
                                    
                                    <Divider />
                                    
                                    <NotificationItem
                                        iconColour = '#FFFFFF'
                                        iconBackgroundColour = '#DFDFDF'
                                        icon = {<SVGIcons.common.NotificationImage />}
                                        when = '10:47 AM'
                                        textMain = 'Images uploaded, need properties'
                                        textSub = 'Updated: October 5, 10:47 AM'
                                        target = 'manage-tasks'
                                        handleItemClick={handleItemClick}
                                    />
                                    
                                    <Divider />
                                    
                                    <ListItemButton
                                        sx={{ textAlign: "center", py: `${12}px !important` }}
                                        onClick={(e) => handleItemClick(e, "manage-tasks")}
                                    >
                                        <ListItemText
                                            primary={
                                                <Typography variant='h6' color='primary'>
                                                    Manage Tasks
                                                </Typography>
                                            }
                                        />
                                    </ListItemButton>
                                    
                                </List>
                            </MainCard>
                        </ClickAwayListener>
                    </Paper>
                </Transitions>
            )}
        </Popper>
    );
};

export default Notification;
